<template>
    <Player
        ref="playerContent"
        :contentId="contentId"
        :video="`${video.secret}/${video.hash}`"
        :progress="progress"
        @info="info"
    />
</template>

<script>

import Player from '../../../Common/Player';

export default {
    name: 'ContentOnDemand',
    props: {
        video: {
            type: Object,
        },
        contentId: {
            type: Number,
            required: true,
        },
    },
    components: {
        Player,
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        async info(result) {
            // Atualiza o progresso do vídeo no banco de dados e retorna o progresso
            // atualizado
            const newProgress = Math.round((result.currentTime / result.duration) * 100);

            if (newProgress <= this.progress || this.loading) return;
            this.loading = true;
            await window.axios
                .post(`/api/app/progress/video/${this.video.id_video}`, {
                    progress: Math.floor(newProgress),
                    time: Math.floor(result.currentTime),
                })
                .catch(err => console.error(err));
            this.loading = false;
            this.$emit('progress', { id: this.video.id_video, progress: Math.floor(newProgress) });
        },
        syncPlayerProgress() {
            this.$refs.playerContent.iframe.contentWindow.postMessage(JSON.stringify({
                public_event: 'jmvplayer-sync',
                screencast: '',
            }), '*');
            window.addEventListener(
                'message',
                (event)  => {
                    this.info(JSON.parse(event.data));
                },
                false
            );
        },
        load() {
            setTimeout(this.syncPlayerProgress, 3000);
        },
    },
    computed: {
        progress() {
            return this.video.progress;
        },
    },
    mounted() {
        this.load();
    }
};
</script>

<style>

</style>
